<template>
  <div style="height: 100%">
    <div
      class="booking-content"
      :style="{ backgroundSize: `100% 300%` }"
      v-if="ifOK"
    >
      <div class="logo-box"><img :src="logo" alt="" ref="logo" /></div>
      <div class="visit-name">{{ invitationInfo.visitorName }}</div>
      <div class="visit-purpose">
        {{ I18nTemplateForRender(invitationInfo.visitPurpose) }} / {{ invitationInfo.visitorNumber
        }}{{ $t('人通行') }}
      </div>
      <div>
        <img src="@/assets/images/douDown.png" alt="" class="booking-img" />
      </div>
      <div>
        <!-- <div
          class="code-box"
          v-if="visitAcceptedStatus && !isLoading && !ifCancel"
          @click="acceptInvitation()"
        >
          <div class="button">
            <span>接受邀约</span>
          </div>
        </div> -->
        <div class="code-box" v-show="!ifCancel">
          <div class="code-bg">
            <img src="@/assets/images/codeBG.png" alt="" />
          </div>
          <div class="code-warp">
            <vue-qr
              :text="invitationInfo.invitationCode"
              :size="136"
              :margin="0"
              ref="qrCode"
              class="code"
            ></vue-qr>
            <div class="verification">
              {{ $t('预约码：') }}{{ invitationInfo.invitationCode }}
            </div>
          </div>
        </div>
      </div>
      <div v-show="ifCancel" class="cancel-invitation">
        <img src="@/assets/images/canInvitation.png" alt="" />
        <p class="cancel-font">{{ status }}</p>
      </div>
      <div class="booking-type1">
        <img src="@/assets/images/who.png" alt="" class="booking-img" />
        <span class="booking-child"
          >{{ $t('被访人：') }}{{ invitationInfo.intervieweeName }}</span
        >
      </div>
      <div class="booking-type1">
        <img src="@/assets/images/visitTime.png" alt="" class="booking-img" />
        <div class="booking-child">
          <div>
            {{ $t('来访时间：')
            }}{{ dayjs(invitationInfo.visitTime).format('YYYY-MM-DD') }}
          </div>
          <div>
            {{ dayjs(invitationInfo.visitTime).format('HH:mm')
            }}{{
              invitationInfo.visitEndTime &&
              `-${dayjs(invitationInfo.visitEndTime).format('HH:mm')}`
            }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="booking-font">
        {{ $t('详细地址：') }}{{ invitationInfo.address || $t('暂无') }}
      </div>
      <div class="booking-font">
        {{ $t('温馨提示：验证信息仅限来访当日进行登记有效！') }}
      </div>
    </div>
  </div>
</template>
<script>
import H5Cropper from 'vue-cropper-h5'
Vue.use(H5Cropper)
import { getCompanyInfo, getVisitFree } from '@/services/api'
import { isMobileType } from '@/utils/isMobileType.js'
import vueQr from 'vue-qr'
import Vue from 'vue'
import  { I18nTemplateForRender } from 'i18n'

export default {
  name: 'publicVisitorInvitationBySelf',
  components: {
    vueQr,
  },
  data() {
    return {
      option: {
        fixedNumber: [9, 16],
        confirmButtonBackgroundColor: '#009BFF',
      },
      height: null,
      ifCancel: false,
      invitationInfo: null,
      logo: null,
      visitorName: '',
      ifOK: false,
      status: null,
      visit: null,
      visitAcceptedStatus: false,
      nameVisit: '',
      isLoading: false,
    }
  },
  methods: {
    I18nTemplateForRender(payload) {
      // 可在此处做一层安全包装或兼容性处理
      try {
        return I18nTemplateForRender(payload)
      } catch (e) {
        // 出错时返回原始值，避免页面崩溃
        console.warn('I18nTemplateForRender error:', e)
        return payload
      }
    },
    // async acceptInvitation() {
    //   Toast('已接受邀约')
    //   this.isLoading = true
    //   const id = this.$route.query.id
    //   const res = await visitStatus({ id })
    //   const res1 = await getVisit({ id })
    //   // console.log('ressss',res1);
    //   this.nameVisit = res1.intervieweeName

    //   setTimeout(() => {
    //     this.visitAcceptedStatus = false
    //     this.isLoading = false
    //   }, 3000)
    // },
    async getLogo(companyCode) {
      const res = await getCompanyInfo(companyCode)
      this.logo = res.logo
      setTimeout(() => {
        if (document.body.clientHeight > 650) {
          this.height = document.body.clientHeight
          if (isMobileType.iOS() && isMobileType.isSafari()) {
            this.height = document.body.clientHeight + 50
          }
        } else {
          this.height = document.body.clientHeight + 100
          setTimeout(() => {
            this.$refs.bookingBox.style.height = this.height + 'px'
          }, 0)
        }
        if (!this.$refs.logo) return
        this.$refs.logo.onload = () => {
          let height = this.$refs.logo.height
          let width = this.$refs.logo.width
          if (height >= width && height >= 78) this.$refs.logo.height = 78
          if (width > height && width >= 94) this.$refs.logo.width = 94
        }
      }, 0)
    },
    async getInfo(id) {
      const res = await getVisitFree({ id })
      this.invitationInfo = { ...res }
      this.visitAcceptedStatus =
        this.invitationInfo.visitAcceptedStatus == 'awaiting'
      if (res.status == 'cancel') {
        this.status = this.$t('已取消')
        this.ifCancel = true
      }
      if (res.status == 'completed') {
        this.status = this.$t('已失效')
        this.ifCancel = true
      }
      this.ifOK = true
    },
  },
  computed: {},
  created() {
    this.getInfo(this.$route.query.id)
    this.getLogo(
      this.$route.query.companyCode ??
        JSON.parse(localStorage.getItem('cCode')).code
    )
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
/deep/.date-border {
  color: #009bff;
}
/deep/ .van-nav-bar .van-icon {
  color: #000000;
}
.abc {
  height: 100%;
}
.cropper {
  width: 54px;
  height: 66px;
  line-height: 66px;
  position: relative;
  overflow: hidden;
  text-align: center;
  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}
.booking-content {
  min-height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 24px;
  font-size: 14px;
  color: #666666;
  background: url('../../../assets/images/shareBGN.png') no-repeat;
  .logo-box {
    width: 110px;
    height: 85px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 26px;
    img {
      max-width: 94px;
      max-height: 78px;
    }
  }
  .visit-name {
    font-size: 17px;
    font-weight: 600;
    color: #373737;
    margin: 20px 0 4px;
  }
  .visit-purpose {
    color: #373737;
    margin-bottom: 12px;
  }
  .line {
    width: 263px;
    height: 1px;
    opacity: 0.19;
    border: 1px solid #a2a2a2;
    margin: 9px 0 15px;
  }
  .booking-type1 {
    display: flex;
    align-items: center;
    width: 250px;
    margin-bottom: 12px;
    .booking-child {
      padding-left: 12px;
    }
  }
  .cancel-invitation {
    margin-top: 40px;
    margin-bottom: 18px;
    height: 161px;
    width: 120px;
    text-align: center;
    img {
      height: 100px;
      width: 100px;
    }
    .cancel-font {
      margin-top: 4px;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }
  .code-box {
    width: 180px;
    min-height: 211px;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    position: relative;
    .code-bg {
      position: absolute;
      img {
        width: 180px;
        height: 211px;
      }
    }
    .code-warp {
      position: absolute;
      z-index: 99;
    }
    .code {
      width: 136px;
      height: 136px;
      margin: 23px auto 16px;
    }
    .verification {
      font-size: 18px;
      font-weight: 600;
      color: #30adff;
      line-height: 24px;
      border-radius: 5px;
      padding: 5px 10px;
    }
    .button {
      font-size: 18px;
      background-color: #009bff;
      color: #fff;
      padding: 10px 35px;
      border-radius: 5px;
      margin-top: 40px;
    }
  }
}
.code-boxOne {
  width: 180px;
  min-height: 211px;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  position: relative;
  left: 20%;
}
.code-boxTwo {
  width: 300px;
  height: 180px;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  position: relative;
}
.code-boxOpen {
  width: 300px;
  height: 180px;
  margin-bottom: 230px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  margin-top: 15px;
}
.code-boxThree {
  width: 300px;
  // height: 180px;
  // margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 10px;
  position: relative;
}
.code-boxFour {
  width: 300px;
  height: 180px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 10px;
  position: relative;
}

.booking-img {
  width: 25px;
  height: 25px;
}
.booking-font {
  width: 264px;
  font-size: 12px;
  color: #a2a2a2;
}
.booking-font:last-child {
  margin-bottom: 100px;
}
.visit-people {
  font-size: 15px;
  font-weight: 600;
  color: #373737;
  margin: 90px 0 9px;
  // position: absolute;
  // top: 82%;
}
.visit-company {
  color: #666666;
  text-align: left;
}
.visit-companyOpen {
  width: 301px;
  height: 48px;
  color: #666666;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  align-items: center;
}
.visit-companyTwo {
  width: 301px;
  height: 48px;
  color: #666666;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  align-items: center;
  // margin-top: 20px;
}
.visit-companyThree {
  width: 301px;
  height: 30px;
  color: #666666;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  align-items: center;
}
.robot-bg {
  position: relative;
  img {
    width: 300px;
    height: 180px;
    margin-bottom: 14px;
  }
}
.robot-bgTwo {
  position: relative;
  img {
    width: 300px;
    height: 90px;
  }
}
.robot-bgThree {
  position: relative;
  img {
    width: 300px;
    height: 180px;
    margin-bottom: 14px;
  }
}
.booking-childTwo {
  margin-bottom: 14px;
}
.booking-childOpen {
  padding-left: 13px;
  margin-bottom: 14px;
  margin-top: 140%;
}
</style>
